import React, { useEffect, useState } from 'react'
import GameSummaryNavigation from './GameSummaryNavigation'
import GameSummary from './GameSummary'
import Banner from './Banner'

const GameSummaryHome = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<div>
			<GameSummaryNavigation />
			{!isMobile && (
				<div style={{ marginTop: '5rem' }}>
					<Banner />
				</div>
			)}
			<GameSummary />
		</div>
	)
}

export default GameSummaryHome
